import { createContext, useContext } from 'react';

export const GlobalNodeSettingsContext = createContext({
  isAiWorkflow: false,
  openForNode: () => {}
});

export function useGlobalNodeSettings() {
  return useContext(GlobalNodeSettingsContext);
}
